import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import type { ISODate } from '../../common/utils';
import { DataObjectUrl } from './DataObjectUrl';
import { DataObjectVersionSchema } from '../schema/DataObjectVersionSchema';

interface LatestDataObjectVersionsParams {
  descriptionId: number;
  valueDateFrom: ISODate;
  valueDateTo: ISODate;
  ruleCode: string;
}

const getLatestDataObjectVersions = (params: LatestDataObjectVersionsParams) =>
  apiClient
    .get(
      expand(DataObjectUrl.LATEST_DATA_OBJECT_VERSIONS, {
        id: params.descriptionId,
        ...params,
      }),
    )
    .then((response) => DataObjectVersionSchema.array().parse(response.data));

export const useLatestDataObjectVersionsQuery = createApiQueryHook(
  ['latest-description-data-object-versions'],
  getLatestDataObjectVersions,
);
